(function () {
  // Local dev fallback when Optimizely has not set abTestParams yet.
  // window.abTestParams = window.abTestParams || {};
  // window.abTestParams.exitIntent = window.abTestParams.exitIntent || {
  //   enabled: true,
  // };

  const OVERRIDABLE_KEYS = [
    'cooldownDays',
    'minScrollDepthRatio',
    'minScrollBackRatio',
    'fastScrollVelocity',
    'mobileBackButtonEnabled',
    'mobileKeyboardDismissEnabled',
    'timeOnPageDesktopEnabled',
    'timeOnPageMobileEnabled',
    'timeOnPageDelayMs',
    'inactivityDelay',
    // Legacy Optimizely keys — mapped in resolveTimeOnPageSettings().
    'mobileFallbackDelayMs',
    'timeOnPageEnabled',
    'sessionLengthSeconds',
    'sessionLengthRatio',
  ];

  function parseConfigFlag(value, defaultValue) {
    if (value == null || value === '') {
      return defaultValue == null ? false : defaultValue;
    }

    if (value === false || value === 'false' || value === 0 || value === '0') {
      return false;
    }

    return !!value;
  }

  function resolveTimeOnPageSettings(settings, baseConfig) {
    settings = settings || {};
    baseConfig = baseConfig || window.FOAExitIntentConfig || settings;

    let delayMs;
    if (settings.timeOnPageDelayMs != null) {
      delayMs = Number(settings.timeOnPageDelayMs);
    } else if (settings.mobileFallbackDelayMs != null) {
      delayMs = Number(settings.mobileFallbackDelayMs);
    } else {
      delayMs =
        Number(settings.sessionLengthSeconds || 120) *
        Number(settings.sessionLengthRatio || 0.75) *
        1000;
    }

    let desktopEnabled;
    if ('timeOnPageDesktopEnabled' in baseConfig) {
      desktopEnabled = parseConfigFlag(settings.timeOnPageDesktopEnabled, false);
    } else if (settings.timeOnPageEnabled != null) {
      desktopEnabled = parseConfigFlag(settings.timeOnPageEnabled, false);
    } else {
      desktopEnabled = false;
    }

    let mobileEnabled;
    if ('timeOnPageMobileEnabled' in baseConfig) {
      mobileEnabled = parseConfigFlag(settings.timeOnPageMobileEnabled, true);
    } else {
      mobileEnabled = true;
    }

    return {
      desktopEnabled: desktopEnabled,
      mobileEnabled: mobileEnabled,
      delayMs: delayMs,
    };
  }

  const EMAIL_PATTERN = /^([0-9a-zA-Z+_.-]*[0-9a-zA-Z]+[@][0-9a-zA-Z+_.-]+\.[0-9a-zA-Z+_.-]*)$/;

  function bindExitIntentSignup() {
    const signupWrapper = document.querySelector('[data-foac-exit-intent-signup]');
    const api = window.foacProspectMarketingSignup;

    if (!signupWrapper || !api || signupWrapper.dataset.foacExitIntentSignupBound === '1') {
      return;
    }

    const form = signupWrapper.querySelector('#foa-exit-form');
    if (!form) {
      return;
    }

    signupWrapper.dataset.foacExitIntentSignupBound = '1';

    const column = signupWrapper.closest('[data-exit-intent-column]');
    const signupPanel = column ? column.querySelector('[data-exit-intent-panel="signup"]') : null;
    const successPanel = column ? column.querySelector('[data-exit-intent-panel="success"]') : null;
    const emailInput = form.querySelector('input[type="email"]');
    const submitBtn = form.querySelector('[type="submit"]');
    const serverError = form.querySelector('[data-exit-intent-server-error]');
    const invalidFeedback = emailInput
      ? emailInput.parentElement.querySelector('.invalid-feedback')
      : null;

    function setEmailValidity() {
      if (!emailInput) {
        return true;
      }

      const value = typeof emailInput.value === 'string' ? emailInput.value.trim() : '';

      if (!value) {
        emailInput.setCustomValidity('Email address is required.');
        if (invalidFeedback) {
          invalidFeedback.textContent = 'Email address is required.';
        }
      } else if (!EMAIL_PATTERN.test(value)) {
        emailInput.setCustomValidity('Email address is invalid.');
        if (invalidFeedback) {
          invalidFeedback.textContent = 'Email address is invalid.';
        }
      } else {
        emailInput.setCustomValidity('');
      }

      const isValid = emailInput.validity.valid;
      emailInput.classList.toggle('is-invalid', form.classList.contains('was-validated') && !isValid);

      return isValid;
    }

    function clearEmailValidationState() {
      if (!emailInput) {
        return;
      }
      emailInput.setCustomValidity('');
      emailInput.classList.remove('is-invalid');
      form.classList.remove('was-validated');
    }

    function clearServerError() {
      if (serverError) {
        serverError.textContent = '';
        serverError.hidden = true;
      }
    }

    function showServerError(message) {
      if (!serverError) {
        return;
      }
      serverError.textContent = message;
      serverError.hidden = false;
    }

    function showSuccess() {
      if (signupPanel) {
        signupPanel.hidden = true;
      }
      if (successPanel) {
        successPanel.hidden = false;
      }
    }

    if (emailInput) {
      emailInput.addEventListener('input', function () {
        clearServerError();
        if (form.classList.contains('was-validated')) {
          setEmailValidity();
        }
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearServerError();

      const isValid = setEmailValidity();
      form.classList.add('was-validated');
      emailInput.classList.toggle('is-invalid', !isValid);

      if (!isValid) {
        if (emailInput) {
          emailInput.focus();
        }
        return;
      }

      if (submitBtn && !api.setLoading(submitBtn)) {
        return;
      }

      const marketingUrlInput = form.querySelector('[name="marketing_url"]');
      if (marketingUrlInput) {
        try {
          const marketingUrl = new URL(window.location.href);
          marketingUrl.searchParams.set('submission_source', 'exit_pop_up');
          marketingUrlInput.value = marketingUrl.toString();
        } catch (error) {
          /* keep server-rendered default */
        }
      }

      api.populateHiddenFields(form);

      api.fetchNonce()
        .then(function (nonce) {
          return api.submitSignup(form, nonce);
        })
        .then(function (result) {
          if (result.body && result.body.success) {
            showSuccess();
            api.pushEmailSignupEvent(signupWrapper);
            form.reset();
            clearEmailValidationState();
            const marketingUrlInput = form.querySelector('[name="marketing_url"]');
            if (marketingUrlInput && marketingUrlInput.defaultValue) {
              marketingUrlInput.value = marketingUrlInput.defaultValue;
            }
            return;
          }

          const errorMessage =
            (result.body && result.body.data && result.body.data.message) ||
            'Something went wrong. Please try again.';
          showServerError(errorMessage);
        })
        .catch(function () {
          showServerError('Something went wrong. Please try again.');
        })
        .finally(function () {
          api.resetLoading(submitBtn);
        });
    });
  }

  function init() {
    const config = window.FOAExitIntentConfig || {};

    // Always bind signup validation/submit — independent of frequency gating.
    bindExitIntentSignup();

    function getAbTestParams() {
      return window.abTestParams || {};
    }

    function getExitIntentAbTest() {
      const exitIntent = getAbTestParams().exitIntent;

      if (exitIntent == null || exitIntent === false) {
        return null;
      }

      if (exitIntent === true) {
        return { enabled: true };
      }

      if (typeof exitIntent === 'object') {
        return exitIntent;
      }

      return null;
    }

    function isEnabledByOptimizely() {
      const abTest = getExitIntentAbTest();
      return abTest != null && abTest.enabled !== false;
    }

    function buildSettings() {
      const settings = Object.assign({}, config);
      const abTest = getExitIntentAbTest();

      if (!abTest) {
        return settings;
      }

      OVERRIDABLE_KEYS.forEach(function (key) {
        if (abTest[key] != null) {
          settings[key] = abTest[key];
        }
      });

      return settings;
    }

    function getVariation() {
      if (!isEnabledByOptimizely()) {
        return '';
      }

      const abTest = getExitIntentAbTest();
      return (abTest && abTest.variation) || 'exit-intent';
    }

    const settings = buildSettings();
    const timeOnPage = resolveTimeOnPageSettings(settings, config);

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function isInactivityEnabled() {
      const delay = settings.inactivityDelay;
      return delay != null && delay !== false && Number(delay) > 0;
    }

    function isFrequencyBlocked() {
      if (config.sessionShownKey && sessionStorage.getItem(config.sessionShownKey)) {
        return true;
      }

      const lastShown = localStorage.getItem(config.lastShownKey);
      if (!lastShown) return false;

      const cooldownMs = Number(settings.cooldownDays || 7) * 24 * 60 * 60 * 1000;
      return Date.now() - Number(lastShown) < cooldownMs;
    }

    if (isFrequencyBlocked()) return;

    const modalEl = document.getElementById('foa-exit-modal');

    if (!modalEl) return;

    let outsideDismissHandler = null;

    function hideModal() {
      const bsModal = getBootstrapModal();
      if (!bsModal) return;

      if (modalEl.classList.contains('show')) {
        bsModal.hide();
        return;
      }

      modalEl.addEventListener(
        'shown.bs.modal',
        function onShown() {
          modalEl.removeEventListener('shown.bs.modal', onShown);
          bsModal.hide();
        }
      );
    }

    function bindOutsideDismiss() {
      if (outsideDismissHandler) return;

      outsideDismissHandler = function (event) {
        if (!modalEl.classList.contains('show')) return;

        const content = modalEl.querySelector('.modal-content');
        if (content && content.contains(event.target)) return;

        event.preventDefault();
        event.stopPropagation();
        hideModal();
      };

      document.addEventListener('click', outsideDismissHandler, true);
    }

    function unbindOutsideDismiss() {
      if (!outsideDismissHandler) return;

      document.removeEventListener('click', outsideDismissHandler, true);
      outsideDismissHandler = null;
    }

    modalEl.addEventListener('shown.bs.modal', function () {
      const trigger = modalEl.dataset.trigger || 'unknown';
      const variation = getVariation();

      document.dispatchEvent(
        new CustomEvent(config.modalDisplayedEvent || 'modal_displayed', {
          detail: {
            trigger: trigger,
            variation: variation,
          },
        })
      );

      const api = window.foacProspectMarketingSignup;
      const signupWrapper = modalEl.querySelector('[data-foac-exit-intent-signup]');
      if (api && signupWrapper && typeof api.pushExitIntentModalDisplayedEvent === 'function') {
        api.pushExitIntentModalDisplayedEvent(signupWrapper, { trigger: trigger, variation: variation });
      }

      bindOutsideDismiss();
    });

    function unwindBackButtonTrap() {
      if (history.state && history.state.foaExitIntent) {
        history.back();
      }
    }

    modalEl.addEventListener('hidden.bs.modal', function () {
      unbindOutsideDismiss();

      const trigger = modalEl.dataset.trigger || 'unknown';
      const variation = getVariation();
      const api = window.foacProspectMarketingSignup;
      const signupWrapper = modalEl.querySelector('[data-foac-exit-intent-signup]');
      if (api && signupWrapper && typeof api.pushExitIntentModalDismissedEvent === 'function') {
        api.pushExitIntentModalDismissedEvent(signupWrapper, { trigger: trigger, variation: variation });
      }

      if (modalEl.dataset.trigger === 'mobile-back-button') {
        unwindBackButtonTrap();
      }
    });

    let shown = false;
    let hasEngaged = false;
    let inactiveTimer = null;
    let timeOnPageTimer = null;
    let lastScrollY = window.scrollY;
    let lastScrollTime = Date.now();
    let maxScrollY = window.scrollY;

    function getModalClass() {
      if (window.bootstrap && window.bootstrap.Modal) {
        return window.bootstrap.Modal;
      }

      if (window.foa && window.foa.Modal) {
        return window.foa.Modal;
      }

      if (window.wholesale && window.wholesale.Modal) {
        return window.wholesale.Modal;
      }

      if (window.understrap && window.understrap.Modal) {
        return window.understrap.Modal;
      }

      return null;
    }

    function getBootstrapModal() {
      const Modal = getModalClass();
      if (!Modal) {
        return null;
      }

      const config = {
        backdrop: true,
        keyboard: true,
      };

      if (!modalEl.dataset.foaExitModalReady) {
        const existing = Modal.getInstance(modalEl);
        if (existing) {
          existing.dispose();
        }

        modalEl.dataset.foaExitModalReady = '1';
      }

      return Modal.getOrCreateInstance(modalEl, config);
    }

    function isAnotherModalOpen() {
      const openModals = document.querySelectorAll('.modal.show');

      for (let i = 0; i < openModals.length; i++) {
        if (openModals[i] !== modalEl) return true;
      }

      return false;
    }

    function getTimeOnPageTriggerName() {
      return isMobile() ? 'time-on-page-mobile' : 'time-on-page-desktop';
    }

    function canShowModal() {
      if (shown) return false;
      if (!isEnabledByOptimizely()) return false;
      if (isAnotherModalOpen()) return false;
      return true;
    }

    function isTimeOnPageEnabled() {
      return isMobile() ? timeOnPage.mobileEnabled : timeOnPage.desktopEnabled;
    }

    function scheduleTimeOnPageTimer() {
      if (!isTimeOnPageEnabled()) return;

      clearTimeout(timeOnPageTimer);
      timeOnPageTimer = setTimeout(function () {
        timeOnPageTimer = null;
        showModal(getTimeOnPageTriggerName());
      }, timeOnPage.delayMs);
    }

    function resetTimeOnPageTimer() {
      if (!isMobile() || !timeOnPage.mobileEnabled) return;
      scheduleTimeOnPageTimer();
    }

    function ensureModalOnBody() {
      if (modalEl.parentElement !== document.body) {
        document.body.appendChild(modalEl);
      }
    }

    function showModal(trigger) {
      if (!canShowModal()) return;

      ensureModalOnBody();

      const bsModal = getBootstrapModal();
      if (!bsModal) return;

      shown = true;
      localStorage.setItem(config.lastShownKey, String(Date.now()));

      if (config.sessionShownKey) {
        sessionStorage.setItem(config.sessionShownKey, '1');
      }

      modalEl.dataset.trigger = trigger || 'unknown';
      bsModal.show();
    }

    function resetInactiveTimer() {
      if (!isInactivityEnabled()) return;

      clearTimeout(inactiveTimer);

      inactiveTimer = setTimeout(function () {
        if (!hasEngaged) return;
        showModal('inactivity');
      }, Number(settings.inactivityDelay));
    }

    function markActivity() {
      if (!isInactivityEnabled()) return;

      hasEngaged = true;
      resetInactiveTimer();
    }

    function isDocumentMouseOut(event) {
      return !event.relatedTarget && !event.toElement;
    }

    function getDesktopTrigger(event) {
      if (!isDocumentMouseOut(event)) return null;
      return 'desktop-mouse-out';
    }

    function handleScrollReturn() {
      resetTimeOnPageTimer();

      const currentY = window.scrollY;
      const now = Date.now();
      const deltaTime = Math.max(now - lastScrollTime, 1);
      const deltaY = lastScrollY - currentY;
      const velocity = deltaY / deltaTime;

      maxScrollY = Math.max(maxScrollY, currentY);

      const scrolledEnough =
        maxScrollY > window.innerHeight * Number(settings.minScrollDepthRatio || 0.5);

      const scrollingUp = currentY < lastScrollY;

      const scrollBackPx = maxScrollY - currentY;
      const scrolledBackEnough =
        scrollBackPx >= window.innerHeight * Number(settings.minScrollBackRatio || 0.15);

      lastScrollY = currentY;
      lastScrollTime = now;

      if (!scrolledEnough || !scrollingUp || !scrolledBackEnough) {
        markActivity();
        return;
      }

      if (velocity >= Number(settings.fastScrollVelocity || 1.2)) {
        showModal('mobile-scroll-return');
      }

      markActivity();
    }

    if (!isMobile()) {
      document.addEventListener('mouseout', function (event) {
        const trigger = getDesktopTrigger(event);
        if (trigger) showModal(trigger);
      });
    }

    if (isMobile()) {
      window.addEventListener('scroll', handleScrollReturn, { passive: true });

      if (timeOnPage.mobileEnabled) {
        ['touchstart', 'keydown', 'click'].forEach(function (eventName) {
          document.addEventListener(eventName, resetTimeOnPageTimer, { passive: true });
        });
      }
    }

    if (isMobile() && settings.mobileBackButtonEnabled) {
      function pushBackButtonTrap() {
        history.pushState({ foaExitIntent: true }, '', window.location.href);
      }

      pushBackButtonTrap();

      window.addEventListener('popstate', function () {
        if (!canShowModal()) {
          return;
        }

        showModal('mobile-back-button');
        pushBackButtonTrap();
      });
    }

    if (isMobile() && settings.mobileKeyboardDismissEnabled) {
      function isPageFormInput(el) {
        if (!el || !el.matches('input, textarea, select')) return false;
        return !el.closest('#foa-exit-modal');
      }

      let hasPageFormFocus = false;

      document.addEventListener('focusin', function (event) {
        if (isPageFormInput(event.target)) {
          hasPageFormFocus = true;
        }
      });

      document.addEventListener('focusout', function (event) {
        if (!isPageFormInput(event.target) || !hasPageFormFocus) return;

        setTimeout(function () {
          const active = document.activeElement;
          if (active && active.matches('input, textarea, select')) return;
          showModal('mobile-keyboard-dismissed');
        }, 300);
      });
    }

    if (isTimeOnPageEnabled()) {
      scheduleTimeOnPageTimer();
    }

    if (isInactivityEnabled()) {
      ['touchstart', 'mousemove', 'keydown', 'click', 'focusin', 'input'].forEach(function (eventName) {
        document.addEventListener(eventName, markActivity, { passive: true });
      });

      resetInactiveTimer();
    }
  }

  // Defer until DOMContentLoaded so deferred Optimizely (head) can set abTestParams first.
  // When readyState is "interactive", deferred theme bundles may not have run yet.
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
